import { ReactElement } from 'react';
import { useDataGridFiltersIndicator } from './model';
import { FiltersIndicatorButton } from './FiltersIndicatorButton';
import { DataGridFiltersIndicatorProps } from './types';

export function DataGridFiltersIndicator({
  excludeField,
  disabled = false,
  title,
  activeFiltersCountOverride,
  isFilterPanelOpenOverride,
  onToggleFiltersOverride,
}: DataGridFiltersIndicatorProps = {}): ReactElement {
  const { activeFiltersCount, onToggleFilters, isFiltersPanelOpenInGrid } =
    useDataGridFiltersIndicator(excludeField);

  return (
    <FiltersIndicatorButton
      activeFiltersCount={activeFiltersCountOverride ?? activeFiltersCount}
      disabled={disabled}
      title={title}
      isOpen={isFilterPanelOpenOverride ?? isFiltersPanelOpenInGrid}
      onToggle={onToggleFiltersOverride ?? onToggleFilters}
    />
  );
}

export { FiltersIndicatorButton } from './FiltersIndicatorButton';
